import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum PalDisciplineEnum {
    "Skilled Nursing" = 1,
    "Physician" = 4,
    "Medical Social Work" = 8,
    "Spiritual Counseling" = 16,
    "Physical Therapy" = 128,
    "Occupational Therapy" = 256,
    "Speech Therapy" = 512,
    "Physician’s Assistant" = 16777216,
    "Care Coordination" = 134217728,
    "Nurse Practitioner" = 67108864,
    "CNA" = 268435456
}

class PalDisciplineClass extends EnumWithDescription<PalDisciplineEnum> {
    public readonly enum = PalDisciplineEnum;
    public readonly enumName: string = "PalDisciplineEnum";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<PalDisciplineEnum>> = new Map([
        [
            "Skilled Nursing",
            {
                value: PalDisciplineEnum["Skilled Nursing"],
                name: "Skilled Nursing"
            }
        ],
        [
            "Physician",
            {
                name: "Physician",
                value: PalDisciplineEnum.Physician
            }
        ],

        [
            "Medical Social Work",
            {
                name: "Medical Social Work",
                value: PalDisciplineEnum["Medical Social Work"]
            }
        ],
        [
            "Spiritual Counseling",
            {
                name: "Spiritual Counseling",
                value: PalDisciplineEnum["Spiritual Counseling"]
            }
        ],
        [
            "Physical Therapy",
            {
                name: "Physical Therapy",
                value: PalDisciplineEnum["Physical Therapy"]
            }
        ],
        [
            "Occupational Therapy",
            {
                name: "Occupational Therapy",
                value: PalDisciplineEnum["Occupational Therapy"]
            }
        ],
        [
            "Speech Therapy",
            {
                name: "Speech Therapy",
                value: PalDisciplineEnum["Speech Therapy"]
            }
        ],
        [
            "Physician’s Assistant",
            {
                name: "Physician’s Assistant",
                value: PalDisciplineEnum["Physician’s Assistant"]
            }
        ],
        [
            "Nurse Practitioner",
            {
                name: "Nurse Practitioner",
                value: PalDisciplineEnum["Nurse Practitioner"]
            }
        ],
        [
            "Care Coordination",
            {
                name: "Care Coordination",
                value: PalDisciplineEnum["Care Coordination"]
            }
        ],
        [
            "CNA",
            {
                name: "CNA",
                value: PalDisciplineEnum.CNA
            }
        ]
    ]);
}

export const PalDiscipline = new PalDisciplineClass();
